module.exports = __webpack_public_path__ + "img/sedang_direview_oleh_asuransi.d9826165.svg";